<app-pdf-viewer-dialog
    *ngIf="selectedOfferLetterTemplate"
    [open]="pdfViewerOpen"
    (closing)="pdfViewerOpen = false"
    [name]="selectedOfferLetterTemplate.name ?? ''"
    #viewer
></app-pdf-viewer-dialog>

<form autocomplete="nope" #form="ngForm">
    <ui-card>
        <app-header [title]="'offer-letter.letterTemplate' | appTranslate"></app-header>
        <div class="ui divider"></div>
        <!-- Warning message if there are no offer letter templates -->
        <ui-banner *ngIf="!offerLetterTemplates?.length" variant="warning" class="margin-y-2">
            <p>{{ 'offer-letter.warningMissingTemplate' | appTranslate }}</p>
        </ui-banner>

        <p>{{ 'offer-letter.selectAnOfferLetterTemplate' | appTranslate }}</p>

        <!-- Offer letter template -->
        <div class="app-grid">
            <mat-form-field class="columns-4 small-columns-8">
                <mat-label appRemoveAriaOwns>{{ 'offer-letter.offerLetterTemplate' | appTranslate }}</mat-label>
                <mat-select
                    name="selectOfferLetterTemplate"
                    [(ngModel)]="selectedOfferLetterTemplate"
                    #selectOfferLetterTemplate="ngModel"
                    required
                    [disabled]="!offerLetterTemplates?.length"
                    [compareWith]="compareWith"
                    (selectionChange)="onSelectOfferLetterTemplate()"
                    placeholder="{{ 'offer-letter.selectTemplate' | appTranslate }}"
                >
                    <mat-option
                        *ngFor="let offerLetterTemplate of offerLetterTemplates"
                        [value]="offerLetterTemplate"
                        >{{ offerLetterTemplate.name }}</mat-option
                    >
                </mat-select>
                <mat-error *ngIf="selectOfferLetterTemplate.invalid">{{
                    selectOfferLetterTemplate.errors | formErrors
                }}</mat-error>
            </mat-form-field>
            <div class="columns-8 small-columns-4 preview">
                <ui-button *ngIf="selectedOfferLetterTemplate" (click)="onPreview()" type="link">{{
                    'offer-letter.previewTemplate' | appTranslate
                }}</ui-button>
            </div>
        </div>
    </ui-card>

    <ui-card *ngIf="offerLetterHasCosigners">
        <app-header [title]="'offer-letter.cosigners' | appTranslate"></app-header>
        <div class="ui divider"></div>

        <ui-banner variant="info" class="margin-y-3">
            <p>{{ 'offer-letter.cosignersHint' | appTranslate }}</p>
        </ui-banner>

        <p>{{ 'offer-letter.selectEmployeesAsCosigners' | appTranslate }}</p>
        <div class="app-grid">
            <div class="columns-4">
                <app-form-multi-signer-assignment
                    [template]="offerLetter.signingTemplate"
                    [assigningOrder]="assigningOrder"
                    (onSlotChange)="updateOfferLetterSlots($event)"
                ></app-form-multi-signer-assignment>
            </div>

            <!-- Greater than 2 because candidate is default in there -->
            <mat-checkbox
                *ngIf="offerLetterHasCosigners && offerLetter?.signingTemplate?.slots?.length > 2"
                name="assigningOrder"
                [ngModel]="assigningOrder"
                (ngModelChange)="assigningOrder = !assigningOrder"
                >{{ 'forms.multi-signer-assignment.assignSigningOrder' | appTranslate }}
            </mat-checkbox>
        </div>
    </ui-card>
</form>
